import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class InsyncAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getInsyncLoginInfo(loginId, router) {
    const url = `/api/insynclogins/${loginId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getInsyncLogins(router) {
    const url = "/api/insynclogins";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createInsyncLogin(params, router) {
    const url = "/api/insynclogins";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateInsyncLogin(loginId, params, router) {
    const url = `/api/insynclogins/${loginId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteInsyncLogin(loginId, router) {
    const url = `/api/insynclogins/${loginId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }
}